import { PageWrapper, rem } from '@innovyze/stylovyze';
import { Grid } from '@mui/material';
import styled from 'styled-components';

export const PageWrapperStyled = styled(PageWrapper)`
	position: relative;
	width: 100%;
	height: 100%;
	max-width: none;
`;

export default PageWrapperStyled;

export const BodyGridStyled = styled(Grid)`
	padding-top: ${rem(24)};
	display: grid;
	column-gap: ${rem(24)};
	row-gap: ${rem(24)};
	grid-template-columns: repeat(auto-fit, minMax(428px, 1fr));
	display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`;

export const MenuGrid = styled.div`
	display: grid;
	grid-template-columns: auto auto;
	grid-gap: ${rem(8)};
`;
